var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      style: { position: "relative" },
      on: {
        mouseover: function ($event) {
          _vm.showButtonBar = true
        },
        mouseout: function ($event) {
          _vm.showButtonBar = false
        },
      },
    },
    [
      _vm.event.EventTypeID == 1
        ? _c("app-crm-message-event", { attrs: { event: _vm.event } })
        : _vm._e(),
      _vm.event.EventTypeID == 2
        ? _c("app-crm-call-event", { attrs: { event: _vm.event } })
        : _vm._e(),
      _vm.event.EventTypeID == 3
        ? _c("app-crm-email-event", { attrs: { event: _vm.event } })
        : _vm._e(),
      _vm.event.EventTypeID == 4
        ? _c("app-crm-appointment-event", { attrs: { event: _vm.event } })
        : _vm._e(),
      _vm.event.EventTypeID == 5
        ? _c("app-crm-close-event", { attrs: { event: _vm.event } })
        : _vm._e(),
      _vm.event.EventTypeID == 6 || _vm.event.EventTypeID == 7
        ? _c("app-crm-sale-event", { attrs: { event: _vm.event } })
        : _vm._e(),
      _vm.event.EventTypeID == 8
        ? _c("app-crm-file-event", {
            attrs: { event: _vm.event },
            on: {
              deleted: function ($event) {
                return _vm.onFileEventEmptied()
              },
            },
          })
        : _vm._e(),
      _c("w-button", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showPinButton || _vm.event.Pinned,
            expression: "showPinButton || event.Pinned",
          },
          {
            name: "tooltip",
            rawName: "v-tooltip",
            value: _vm.$ct(_vm.event.Pinned ? "unpin-history" : "pin-history"),
            expression: "$ct(event.Pinned ? 'unpin-history':'pin-history')",
          },
        ],
        staticClass: "pin",
        class: { pinned: _vm.event.Pinned },
        attrs: { icon: "thumbtack", flat: "" },
        on: {
          click: function ($event) {
            return _vm.pin()
          },
        },
      }),
      _c(
        "w-button-bar",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showButtonBar,
              expression: "showButtonBar",
            },
          ],
        },
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct(
                    _vm.event.Pinned ? "unpin-history" : "pin-history"
                  ),
                  expression:
                    "$ct(event.Pinned ? 'unpin-history':'pin-history')",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.pin()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "thumbtack" } })],
            1
          ),
          _vm.event.EventTypeID == 1 ||
          _vm.event.EventTypeID == 2 ||
          _vm.event.EventTypeID == 8
            ? _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.edit"),
                      expression: "$ct('common.edit')",
                    },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.edit()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "pen" } })],
                1
              )
            : _vm._e(),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("common.delete"),
                  expression: "$ct('common.delete')",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.remove()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "trash" } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }